var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArprojects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.998,
    height: 42.001,
    viewBox: "0 0 44.998 42.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ar_projects",
    "data-name": "ar projects",
    transform: "translate(-1.501 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M36,39a4.5,4.5,0,1,0-4.224-6H19.5v1.5A7.5,7.5,0,1,1,12,27V24A10.5,10.5,0,1,0,22.393,36h9.383A4.486,4.486,0,0,0,36,39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M36,24a10.536,10.536,0,0,0-3.855.731L27.4,16.42a4.571,4.571,0,1,0-2.6,1.5l6.178,10.812,1.3-.747A7.5,7.5,0,1,1,29.5,38.249l-2.6,1.5A10.5,10.5,0,1,0,36,24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M12.8,30.081a4.545,4.545,0,1,0,2.6,1.5l5.438-9.516.747-1.3-1.3-.746A7.5,7.5,0,1,1,30.5,17.249l2.6,1.5a10.5,10.5,0,1,0-15.519,3.054c-.686,1.113-1.653,2.806-3.11,5.358Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArprojects);
export default __webpack_public_path__ + "static/media/arprojects.09879adb265cdf70bb994ab52aebe02c.svg";
export { ForwardRef as ReactComponent };